import { captureException, captureMessage } from '@sentry/react';
import type { Primitive } from 'utility-types';

type CaptureContext = Parameters<typeof captureException>[1];

const logError = (error: Error, context?: CaptureContext) =>
  captureException(error, context);
const logWarning = (warning: string) => captureMessage(warning, 'warning');
const logInfo = (message: string) => captureMessage(message, 'info');

export { logError, logWarning, logInfo };

type Tags = {
  orgId?: Primitive;
  featureName?: Primitive;
};

export const logErrorWithTags = (error: Error, tags: Tags) => {
  captureException(error, { tags });
};
